export type BlogBlock =
  | { type: "paragraph"; text: string }
  | { type: "heading"; text: string }
  | { type: "list"; items: string[] }
  | { type: "image"; src: string; alt: string; caption?: string }
  | { type: "quote"; text: string; author?: string }
  | { type: "video"; embedUrl: string; title: string; caption?: string };

export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  coverImage: string;
  highlights: string[];
  blocks: BlogBlock[];
}

export const blogPosts: BlogPost[] = [
  {
    slug: "champions-in-spirit",
    title: "Champions in Spirit: Sainik School Sujanpur Tira's Girls Bring Home the National U-17 Football Title",
    excerpt: "Sainik School Sujanpur Tira’s girls made history by winning the National Under-17 Football Championship, proudly supported by us.",
    category: "Field Stories",
    author: "Immerse Foundation Team",
    date: "2026-08-02",
    readTime: "7 min read",
    coverImage: "/Football%20Girl.png",
    highlights: [
      "Community support boosts participation.",
      "Girls need visible, practical encouragement.",
      "Simple interventions can create lasting confidence.",
    ],
    blocks: [
      {
        type: "paragraph",
        text: "The girls' football team of Sainik School Sujanpur Tira achieved something extraordinary by winning the Under-17 All India Football Championship (Pre-Subroto Cup 2026), defeating Sainik School Chandrapur in a thrilling final to emerge as national champions. Competing against teams from across the country, they displayed remarkable discipline, resilience, teamwork and composure under pressure—qualities that define both great sport and great character.",
      },
      {
        type: "image",
        src: "/football1.jpeg",
        alt: "Girls football team on the field",
        caption: "The team representing Sainik School Sujanpur Tira at the Under-17 All India Football Championship.",
      },
      {
        type: "paragraph",
        text: "For everyone associated with the school, this victory is far more than a sporting achievement. It reflects years of dedicated coaching, disciplined training and a culture that encourages young cadets to strive for excellence in every field. Sainik School Sujanpur Tira has long been recognised for shaping leaders, and this remarkable accomplishment is another chapter in that proud legacy.",
      },
      {
        type: "paragraph",
        text: "At the Immerse Foundation, we feel privileged to have played a very small part in this journey. As part of our commitment to supporting young talent in Himachal Pradesh through meaningful corporate responsibility initiatives, we had the honour of sponsoring the team's football jerseys.",
      },
      {
        type: "image",
        src: "/football3.jpeg",
        alt: "Girls football team on the field",
        caption: "For our Director, Alka Sharma, it was a pleasure meeting the young champions who won the All India Under-17 Football Championship.",
      },
      {
        type: "paragraph",
        text: "Watching these young champions compete on the national stage wearing those jerseys was a moment of quiet pride for everyone at the Foundation. The victory belongs entirely to the players, their coaches, their families and the school. Our contribution was simply a gesture of encouragement to a team whose determination had already set them apart.",
      },
      {
        type: "video",
        embedUrl: "/video.mp4",
        title: "Champions’ Celebration After the Final Whistle",
        caption: "The Sainik School Sujanpur Tira girls celebrate their victory after winning the All India Under-17 Football Championship, sharing a joyful moment with their coach after the final match.",
      },
      {
        type: "paragraph",
        text: "This achievement also holds a special place in the heart of the Immerse Foundation. Our founder, Ujjwal, is an alumnus of Sainik School Sujanpur Tira, and his connection with the institution runs deep. Supporting the next generation of cadets from the school that helped shape his own journey made this initiative especially meaningful.",
      },
      {
        type: "image",
        src: "/Trophy.jpg",
        alt: "Girls football news article",
        caption: "Credit: Tribune India",
      },
      {
        type: "paragraph",
        text: "Congratulations to every player, coach, teacher and member of the Sainik School Sujanpur Tira community. Your achievement is an inspiration not only to aspiring footballers but to every young person who believes that discipline, perseverance and teamwork can turn dreams into reality.",
      },
      {
        type: "paragraph",
        text: "May this national title be the first of many, and may these young champions continue to inspire countless others in the years ahead.",
      },
    ],
  },
//   {
//     slug: "transparency-that-builds-trust",
//     title: "Transparency That Builds Trust in Community Projects",
//     excerpt:
//       "Why impact updates, simple reporting, and visible progress matter for donors, partners, and local communities.",
//     category: "Impact",
//     author: "Immerse Foundation Team",
//     date: "2026-06-28",
//     readTime: "5 min read",
//     coverImage: "/Partner%20with%20us.jpg",
//     highlights: [
//       "Trust grows when progress is visible.",
//       "Updates should be easy to read and easy to verify.",
//       "Media-rich reporting helps communities tell their own story.",
//     ],
//     blocks: [
//       {
//         type: "paragraph",
//         text: "Transparency is not a design feature; it is part of the service itself. If someone supports a project, they should be able to see what happened, where it happened, and why it mattered.",
//       },
//       {
//         type: "image",
//         src: "/Partner%20with%20us.jpg",
//         alt: "Community partnership scene",
//       },
//       {
//         type: "quote",
//         text: "Good reporting is not about making a project look bigger. It is about making the truth easier to understand.",
//         author: "Program Team",
//       },
//       {
//         type: "list",
//         items: [
//           "Use short update notes that explain the action taken.",
//           "Add photos, captions, and videos when the story benefits from context.",
//           "Keep the language human and specific rather than generic.",
//         ],
//       },
//       {
//         type: "video",
//         embedUrl: "https://www.youtube.com/embed/jfKfPfyJRdk",
//         title: "Project update video",
//         caption: "Use embedded videos for testimonials, site visits, or milestone recaps.",
//       },
//       {
//         type: "paragraph",
//         text: "When reporting is simple and honest, it does more than inform. It creates the conditions for repeat support and long-term credibility.",
//       },
//     ],
//   },
//   {
//     slug: "rural-learning-and-digital-skills",
//     title: "Rural Learning and Digital Skills for the Next Generation",
//     excerpt:
//       "A closer look at how foundational digital literacy and learning support can widen opportunity for rural students.",
//     category: "News",
//     author: "Immerse Foundation Team",
//     date: "2026-06-09",
//     readTime: "7 min read",
//     coverImage: "/Books.jpg",
//     highlights: [
//       "Skills work best when tied to local aspirations.",
//       "Digital literacy unlocks confidence as well as access.",
//       "Learning resources should be practical, not abstract.",
//     ],
//     blocks: [
//       {
//         type: "paragraph",
//         text: "Education support works best when it solves a real obstacle for the learner. In many rural settings, that obstacle is not motivation; it is access to tools, guidance, and exposure.",
//       },
//       {
//         type: "image",
//         src: "/Books.jpg",
//         alt: "Books and learning materials",
//         caption: "Learning resources create a foundation for confidence and participation.",
//       },
//       {
//         type: "heading",
//         text: "What good learning support looks like",
//       },
//       {
//         type: "list",
//         items: [
//           "Clear, age-appropriate materials that are easy to use.",
//           "Simple pathways into digital literacy and future-ready skills.",
//           "Support that respects local context and the pace of each learner.",
//         ],
//       },
//       {
//         type: "paragraph",
//         text: "We are building content that keeps that structure visible on the website: strong headlines, readable paragraphs, images for context, and videos where motion and voice add meaning.",
//       },
//     ],
//   },
];

export function getBlogPost(slug: string) {
  return blogPosts.find((post) => post.slug === slug);
}